import React from 'react';
import PropTypes from 'prop-types';
import {
  Box, FormControl, InputLabel, Select,
} from '@mui/material';
import { useStyles } from './styles';
import Loader from '../../../commons/Loader';
import { inputDataCustom } from '../../../../utils/custom_prop_types/customPropTypes';

export default function ColorSection({
  loader,
  colors,
  inputData,
  setInputDataToSend,
}) {
  const classes = useStyles();
  const handleColorSelectChange = ({ currentTarget }) => {
    const selectedColor = currentTarget[currentTarget.selectedIndex].getAttribute('data-value');
    setInputDataToSend('color', selectedColor);
    setInputDataToSend('panelDescription', '');
  };

  return (
    <Box className={classes.inputWrapper}>
      <FormControl variant="standard" className={classes.form}>
        <InputLabel id="color-label">Color</InputLabel>
        <Select
          disabled={loader.color}
          className={classes.colorSelect}
          native
          onChange={handleColorSelectChange}
          color="secondary"
          variant="standard"
          value={inputData.color || ''}
        >
          <option aria-label="None" />
          {colors.uniqueAttributesValues?.map((color) => (
            <option data-value={color} key={color}>{color}</option>
          ))}
        </Select>
      </FormControl>
      <Loader target="color" offsetRight={48} size={18} centeredY />
    </Box>
  );
}

ColorSection.propTypes = {
  loader: PropTypes.objectOf(PropTypes.bool).isRequired,
  colors: PropTypes.shape({
    uniqueAttributesValues: PropTypes.arrayOf(PropTypes.string),
  }).isRequired,
  inputData: inputDataCustom.isRequired,
  setInputDataToSend: PropTypes.func.isRequired,
};
